import React, { useState } from "react";
import CommentIcon from "@mui/icons-material/Comment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import moment from "jalali-moment";
import { useNavigate } from "react-router-dom";

// import JS files

// import others files

const NewsCard = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="grid md:grid-cols-12 gap-8 bg-mygrays-100 md:bg-transparent rounded-lg md:rounded-none md:border-b md:border-b-mygrays-200 last:border-b-0 p-4 md:p-0 md:pb-8 last:pb-0 my-4 text-hover-container cursor-pointer transition-all"
        onClick={() => navigate(`/news-content/${props.id}`)}
      >
        <div className="md:col-span-3 flex flex-col justify-center">
          <img src={props.img} className="rounded-lg h-3/4" />
        </div>
        <div className=" md:col-span-9 flex flex-col">
          <span
            className=" text-myblacks-300 text-justify text-xs md:text-sm"
            style={{ lineHeight: 2 }}
          >
            {props.sub_header}
          </span>
          <span className="mt-4  font-bold text-myblacks-400 text-base md:text-lg text-justify text-hover">
            {props.header}
          </span>
          {/* <div className="text-justify mt-4  leading-7 md:leading-8">
            <span className=" text-myblacks-300   text-sm md:text-base">
              {props.brief_description}
            </span>
          </div> */}

          <div className="flex justify-end text-xs text-myblacks-100 mt-4 md:mt-8">
            <div className="flex items-center">
              <CommentIcon sx={{ fontSize: "1rem" }} />
              <span className="mr-1">{props.comment} نظر</span>
            </div>
            <div className="flex items-center mr-8">
              <CalendarMonthIcon sx={{ fontSize: "1rem" }} />
              <span className="mr-1" style={{ fontFamily: "yekan" }}>
                {" "}
                {moment(props.date, "YYYY/MM/DD")
                  .locale("fa")
                  .format("YYYY/MM/DD")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsCard;
